import { useEffect } from 'react';
const PUBLIC_CDXP_API_KEY = import.meta.env.VITE_PUBLIC_CDXP_API_KEY
const PUBLIC_CDXP_SOURCE_IDENTIFIER = import.meta.env.VITE_PUBLIC_CDXP_SOURCE_IDENTIFIER
const PUBLIC_CDXP_ANDROID_API_KEY=import.meta.env.VITE_PUBLIC_CDXP_ANDROID_API_KEY
const PUBLIC_CDXP_ANDROID_SOURCE_ID = import.meta.env.VITE_PUBLIC_CDXP_ANDROID_SOURCE_ID
const PUBLIC_CDXP_IOS_API_KEY = import.meta.env.VITE_PUBLIC_CDXP_IOS_API_KEY
const PUBLIC_CDXP_IOS_SOURCE_ID = import.meta.env.VITE_PUBLIC_CDXP_IOS_SOURCE_ID

const Cdxp = () => {

  useEffect(() => {
    // Create the script element dynamically for the GTM script
    const cdxpScript = document.createElement('script');
    cdxpScript.textContent  = `
    (function () {
      var globalAnalyticsKey = "Binoban";
      var Binoban = (window[globalAnalyticsKey] = window[globalAnalyticsKey] || []);
      if (Binoban.initialize) return;
      if (Binoban.invoked) {
        if (window.console && console.error) {
          console.error("Binoban snippet included twice.");
        }
        return;
      }
      Binoban.invoked = true;
      Binoban.methods = [
        "trackSubmit",
        "trackClick",
        "trackLink",
        "trackForm",
        "pageview",
        "identify",
        "reset",
        "group",
        "track",
        "ready",
        "alias",
        "debug",
        "page",
        "screen",
        "once",
        "off",
        "on",
        "addSourceMiddleware",
        "addIntegrationMiddleware",
        "setAnonymousId",
        "addDestinationMiddleware",
        "register",
        "loadDisplayAds",
        "setWebviewInfo",
      ];
    
      Binoban.factory = function (e) {
        return function () {
          if (window[globalAnalyticsKey].initialized) {
            return window[globalAnalyticsKey][e].apply(
              window[globalAnalyticsKey],
              arguments,
            );
          }
          var args = Array.prototype.slice.call(arguments);
    
          if (
            ["track", "screen", "alias", "group", "page", "identify"].indexOf(e) >
            -1
          ) {
            var c = document.querySelector("link[rel='canonical']");
            args.push({
              __t: "bpc",
              c: (c && c.getAttribute("href")) || undefined,
              p: location.pathname,
              u: location.href,
              s: location.search,
              t: document.title,
              r: document.referrer,
            });
          }
    
          args.unshift(e);
          Binoban.push(args);
          return Binoban;
        };
      };
    
      for (var i = 0; i < Binoban.methods.length; i++) {
        var key = Binoban.methods[i];
        Binoban[key] = Binoban.factory(key);
      }
    
      Binoban.load = function (options) {
        var t = document.createElement("script");
        t.type = "text/javascript";
        t.async = true;
        t.setAttribute("data-global-analytics-key", globalAnalyticsKey);
        t.src = options.host.sdkPath;
    
        var first = document.getElementsByTagName("script")[0];
        first.parentNode.insertBefore(t, first);
        Binoban._apiKey = options?.credentials.apiKey;
        Binoban._sourceIdentifier = options?.credentials.sourceIdentifier;
        Binoban._loadOptions = options;
      };
    
      Binoban.SNIPPET_VERSION = "1.1.1";
    
      Binoban.load({
        credentials: {
          apiKey: "${PUBLIC_CDXP_API_KEY}",
          sourceIdentifier: "${PUBLIC_CDXP_SOURCE_IDENTIFIER}",
        },
        host: {
          rtbPath: "https://ssp-cdxp.ozone.ir",
          sdkPath: "https://static-cdxp.ozone.ir/sdk/web/binoban.js",
          apiPath: "https://api-cdxp.ozone.ir",
          metricPath: "https://kilo-cdxp.ozone.ir",
        },
        mobileApp: {
          loadedInWebview: window.isOpenedInApplication,
          androidCredentials: {
            apiKey: "${PUBLIC_CDXP_ANDROID_API_KEY}",
            sourceIdentifier: "${PUBLIC_CDXP_ANDROID_SOURCE_ID}",
          },
          iosCredentials: {
            apiKey: "${PUBLIC_CDXP_IOS_API_KEY}",
            sourceIdentifier: "${PUBLIC_CDXP_IOS_SOURCE_ID}",
          },
        },
      });
    })();
    `;
    cdxpScript.async = true;
    document.head.appendChild(cdxpScript);

    return () => {
      document.head.removeChild(cdxpScript);
    };
  }, []);
  return null; // This component doesn't render anything visible
};

export default Cdxp;
